<div *ngIf="orderStatusCounts && orderStatusCounts.length > 0" class="order-status-container">
    <div *ngFor="let item of orderStatusCounts" class="d-inline-block me-1 mb-1">
        <app-order-status-badge [id]="item.orderStatusId" [count]="item.count"></app-order-status-badge>
    </div>
</div>
<div *ngIf="!orderStatusCounts || orderStatusCounts.length === 0" class="text-muted">
    <small>-</small>
</div>












